
import { MapLayoutConfig } from './types';

export const GOOGLE_SHEETS_CSV_URL = 'https://mosa8.ahelper.workers.dev/'; 

export const MAP_CONFIG: MapLayoutConfig = {
  gridWidth: 50,
  gridHeight: 30,
  columns: ['H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'],
  columnCounts: {
    A: 14,
    B: 30,
    C: 30,
    D: 12,
    E: 12,
    F: 30,
    G: 30,
    H: 20
  },
  spacings: {
    'H-G': 130,
    'G-F': 30,
    'F-E': 80,
    'E-D': 30,
    'D-C': 80,
    'C-B': 30,
    'B-A': 130
  }
};

export const COLORS = {
  active: '#FF8C00',
  activeText: '#FFFFFF',
  default: '#FFFFFF',
  defaultText: '#000000',
  inactive: 'rgba(200, 200, 200, 0.5)',
  highlight: '#FFF4E5'
};
